import React, {useContext} from "react";
import CredentialsContext from "../contexts/CredentialsContext";
import getGame from "../../js/utils/async/getGame";
import useGame from "../hooks/useGame";
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import useLogin from "../hooks/useLogin";


export default async function Game(){
    const {credentials} = useContext(CredentialsContext);



    const location = useLocation();
    const {state} = location;
    let link = state.link;
    console.log(state);
    let {game, isLoaded, isLogged} = useGame(credentials, link);
    console.log(game);

    return(
        <>{isLoaded ? <>{
            isLogged ? <div dangerouslySetInnerHTML={{ __html: game }} /> : <div>Вы не авторизованы</div>}</> :
        <div>Загрузка</div>}</>);
}